import { FAQ_LINK_PLACEHOLDER_REGEX } from '../../utils/faqLinkUtils';

export function enhanceFaqLinkPlaceholders(root: HTMLElement): void {
  const linkRegex = new RegExp(FAQ_LINK_PLACEHOLDER_REGEX.source, FAQ_LINK_PLACEHOLDER_REGEX.flags);
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes: Text[] = [];
  let node: Node | null;

  while ((node = walker.nextNode())) {
    const textNode = node as Text;
    linkRegex.lastIndex = 0;
    if (linkRegex.test(textNode.nodeValue || '')) {
      nodes.push(textNode);
    }
  }

  for (const textNode of nodes) {
    const text = textNode.nodeValue || '';
    const fragment = document.createDocumentFragment();
    let last = 0;
    const replaceRegex = new RegExp(
      FAQ_LINK_PLACEHOLDER_REGEX.source,
      FAQ_LINK_PLACEHOLDER_REGEX.flags,
    );

    text.replace(replaceRegex, (match, group, question, offset) => {
      if (offset > last) {
        fragment.appendChild(document.createTextNode(text.slice(last, offset)));
      }
      const anchor = document.createElement('a');
      anchor.href = '#';
      anchor.className = 'faq-link';
      anchor.textContent = question ? `${group}: ${question}` : group;
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
        window.dispatchEvent(
          new CustomEvent('faq-link-click', {
            detail: {
              group: String(group).trim(),
              question: question ? String(question).trim() : undefined,
            },
          }),
        );
      });
      fragment.appendChild(anchor);
      last = offset + match.length;
      return match;
    });

    if (last < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(last)));
    }
    textNode.parentNode?.replaceChild(fragment, textNode);
  }
}
